import { BaseMutableModel } from '../common-models/base-mutable-model.model';
import ICalibrationBonus = ZoneIQCalibration.ICalibrationBonus;


export class CalibrationBonusValue extends BaseMutableModel<ICalibrationBonus> implements ICalibrationBonus {

    public ZoneCombinationId: number;
    public OverlayTypologyId?: any;
    public RevisionId: number;

    public LevelBonus?: number;
    public HeightBonus?: any;
    public FLRBonus?: number;
    public BrownfieldRedevelopment?: number;
    public ParkingReductionBonus?: any;

    constructor(data: ICalibrationBonus, fieldSettings?: any) {
        super(data, ['ZoneCombinationId', 'OverlayTypologyId'], fieldSettings);
    }

    static factory(data: ICalibrationBonus): CalibrationBonusValue {
        return new CalibrationBonusValue(data);
    }
}
